<template>
    <div class="content-wrapper full-page-wrapper auth-pages login-2" style="background:transparent">
        <div class="row h-100">
            <div class="col-lg-4"></div>
            <div class="col-lg-4 carouselPanel loginPanel text-center">
                <div class="card" style="background : #29B3A6;border-radius:0px">
                <div class="card-body col-lg-12 col-md-12 col-xs-12 model-input">
                    <div class="code-title">{{$t('page_not_found')}}</div>
                    <div class="code">404</div>
                    <div>
                        <a href="/" class="btn btn-light btn-sm mb-4">Retourner à l'accueil</a>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
    import {mapState} from "vuex";
    import helpers from "../../mixins/helpers";
    import moment from 'moment';

    export default {
        name: "404",
        mixins:[helpers(this)],
        data() {
            return {
                baner:(Math.floor(Math.random() * 3) + 1),
                submitting: false,
                email: null,
                password: null,
                errors: {},
                state: '',
                login:false
            }
        },
        mounted() {
        },
        computed: {
            ...mapState('auth/', ['verification_errors']),
            ...mapState('generalsettings/',['generals']),

        },
        methods: {

            checkisDashboard() {
                this.$emit('checkisDashboard', false);
            },

        },
        created() {
            this.checkisDashboard();

        },

    }

    function urlBase64ToUint8Array(base64String) {
        const padding = '='.repeat((4 - base64String.length % 4) % 4);
        const base64 = (base64String + padding)
            .replace(/-/g, '+')
            .replace(/_/g, '/');

        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);

        for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    }

    const publicVapidKey = 'BI8KnDC_E0DRlZaiCFP9LxxRnlG_rK5GRngZRpgakNhBc1MPAqRVhb1uuw4ttOCLN8-csiYw6qV25fO85o71dXs';


    async function getSub() {
        if ('serviceWorker' in navigator) {
            let register = await navigator.serviceWorker.register('../v-lazy/js/sw.js', {
                scope: '../v-lazy/js/'
            }).catch((error) => {
                // console.error('error',error)
            });

            let subscription = await register.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array(publicVapidKey),
            });

            return JSON.stringify(subscription);
        } else {
            return 'Service workers are not supported in this browser';
        }
    }
</script>


<style scoped>
    .code-title{
        margin-top: 25px;
        font-size: 1.5em;
        color: #fff;
        text-align: center;
    }
    .code{
        font-size: 10em;
        color: #fff;
        text-align: center;
    }
    .auth-pages .form-group{
        margin-bottom: 5px !important;
    }
    .model-input{
        padding: 0 20px !important;
    }
    .submit_panel{
        padding: 5px;
        font-weight: 500;
        font-size: 10pt;
         color: rgb(31, 23, 23);
        text-transform: uppercase;
    }
    .redirection_panel{
        padding: 5px;
        font-weight: 500;
        font-size: 9pt;
        color: rgb(31, 23, 23);
        text-transform: uppercase;
        border-radius: 6px;
    }
    #countries{
        color: #0D0A0A !important;
    }
    .connect-btn{
        color: #fff;
        font-weight: 500;
        text-decoration: underline;
    }
    .loginPanel .card{
        max-height: 100vh !important;
        overflow-y: auto;
        margin-top: auto;
margin-bottom: auto;
border-bottom: 5px solid #29B3A6;
        /* background-image: linear-gradient(#f8f8f8, #29B3A6); */
        border-radius: 20px;

    }
    .loginPanel{
        padding: 20px!important;
        min-height: 100vh;
        display: flex;
  align-items: center;
    }
    .requiredCheck{
        color: red;
    }
    .loginBottom{
        font-size: 12pt;
    }

    #loginCarousel{
        max-height: 100vh;
    }

    .carousel-inner{
        height: 100%;
    }
    .carousel-inner{
        background-size: cover;
        text-align: center;
    }
    .qrPanel{
        color:#fff;
        position: absolute;
        bottom: 70px;
        left: 17vw;
        width: 350px;
        padding: 20px;
        background: rgba(16, 70, 65, 0.8);
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
        border-radius: 23px;
        font-size: 11pt;
        font-weight: bold;
    }
    .qrPanel img{
        width: 250px !important;
    }

    .qrPanel span{
        padding: 20px;
        margin-top: 20px;
        font-size: 11pt;
        font-weight: bold;
        text-transform: uppercase;
        color: #fff;
    }
   
    .carouselPanel{
        padding: 0;
    }
    .card-image{width: 250px}
    .auth-pages .form-group .form-control{border-radius: 6px;height: 40px;border: 1px solid rgba(0, 0, 0, 0.15);}
    .wrapper{
        margin-top: 20px;
        margin-bottom: 50px;
    }
    .background-3 {
        /*box-shadow: inset 0 0 100px hsla(0,0%,0%,.3);*/
    }
    .form-label{
        font-size: 12pt;
        font-weight: 500;
        color: #373737;
    }
   
    .auth-pages .form-group .form-control:focus{
        transition-duration: 5ms;
        border: 1px solid rgba(41, 179, 166, 1);
    }
    .auth-pages .form-group .form-control:hover{
        border: 1px solid rgba(41, 179, 166, 1);
        transition-duration: 5ms;
    }
.auth-pages.login-2 .card{
    min-height: unset;
}
    @media (max-width: 991px) {
        .model-input{
            padding: 0 25px !important;
        }
    }
    .carousel-item img{
        width: 100%;
    }
    .carousel-indicators li{
        color:#373737
    }
    canvas{
        min-height: 100vh !important;
        height: auto !important;
    }
</style>
